import { jsxs as e, jsx as a, Fragment as i } from "react/jsx-runtime";
import { u as s } from "../index-DvpE_B3z.js";
import { Spinner as c } from "../shared/spinner/Spinner.component.js";
import { UploadCloudIcon as f } from "./icons/UploadCloud.icon.js";
const N = ({
  copies: p,
  onDrop: r,
  accept: l,
  disabled: t,
  isLoading: o
}) => {
  const { getRootProps: n, getInputProps: m, open: d } = s({
    onDrop: r,
    multiple: !0,
    accept: l,
    noClick: !0,
    disabled: t
  });
  return /* @__PURE__ */ e(
    "div",
    {
      ...n(),
      className: "app:border-1 app:border-dashed app:border-stone-400 app:rounded-xl app:flex app:flex-col app:items-center app:justify-center app:py-8 app:my-10 app:h-36 app:min-h-36 app:cursor-pointer",
      onClick: d,
      children: [
        /* @__PURE__ */ a("input", { ...m() }),
        o ? /* @__PURE__ */ a(c, { className: "app:w-5 app:h-5" }) : /* @__PURE__ */ e(i, { children: [
          /* @__PURE__ */ a(f, { className: "app:w-10 app:h-10 app:min-h-10 app:mb-2" }),
          /* @__PURE__ */ e("div", { className: "app:flex app:flex-col app:gap-2", children: [
            /* @__PURE__ */ a("div", { className: "app:font-semibold", children: p == null ? void 0 : p.fileExplorer.fileInput.dragDrop }),
            /* @__PURE__ */ a("div", { className: "app:text-stone-400 app:text-sm", children: p == null ? void 0 : p.fileExplorer.fileInput.clickBrowse })
          ] })
        ] })
      ]
    }
  );
};
export {
  N as FileUploadWidget
};
